export default {
  translation: {
    shopButton: 'Agregar al carrito',
    buttonsHeader: 'Compra ingredientes en línea',
    unavailableTitle: 'Lamentablemente, no entregamos los ingredientes en tu dirección. Encuentra tiendas físicas cerca de ti donde puedes comprar nuestros productos.',
    unavailableButtonLabel: 'Encuentra ahora',
    viewAll: 'Ver todo',
    substitutionButtonLabel: 'Personaliza con IA'
  }
}
